import React from "react";
import moment from "moment";

function TodayDateTime() {
  return (
    <div
      className="f14-500 mb-2 mt-2"
      style={{ color: "#EE3A23" }}
      align="right"
    >
      {moment().format("lll")}
    </div>
  );
}

export default TodayDateTime;
